import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { emailRegEx } from './patterns';

/**
 * Reemplazo de `Validators.email` (que acepta `123@123`) con la regla `emailRegEx`.
 * Devuelve el mismo error `email`, así que los `hasError('email')` existentes siguen funcionando.
 */
export const emailValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const value = (control.value ?? '').toString().trim();
    if (!value) return null; // El vacío lo controla Validators.required
    return emailRegEx.test(value) ? null : { email: true };
};
